<template>
    <div id="main-container">
        <div id="advanced-trend-data-container">
            <div v-if="!advancedTrendsLoaded" id="trend-data-loading" style="text-align: center; margin-top: 200px;">
                <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div>Loading device trend data...</div>
            </div>

            <div id="form-elements" style="display: inline-flexbox;">
                <date-picker v-model="time3" type="datetime" range valueType="x"></date-picker>
                <b-button id="btnLoadTrends" @click="loadTrends()" variant="outline-primary" :disabled="!(time3)">Load Trends</b-button>
            </div>

            <!-- Trends Chart -->
            <div v-if="advancedTrendsFound">
                <div id="trends-chart" >
                    <highcharts constructor-type="stockChart" :options="advancedTrendChartOptions" :updateArgs="updateArgs">
                    </highcharts>
                </div>
            </div>
            <div v-else>
                No data found for search period, please try again.
            </div>

            <div id="live-update-switch">
                <b-form-checkbox v-model="refreshAdvancedTrendsActive" name="check-button" switch>
                    Live Data
                </b-form-checkbox>
            </div>
        </div>

    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
    name: 'AdvancedTrends',
    components: {
        DatePicker,
    },
    data: function () {

        return {

            time3: null,

            advancedTrendsLoaded: false,

            refreshAdvancedTrendsDataIntervalID: null,
            refreshAdvancedTrendsActive: true,

            advancedTrendSeries: [],
            advancedTrendsFound: false,

            trendStartStamp: (Math.round(+new Date()/1000) - 28800), // Default to 8 hours worth
            trendEndStamp: Math.round(+new Date()/1000),

            /*chartType: 'Spline',
            seriesColor: '#6fcd98',
            colorInputIsSupported: null,
            animationDuration: 1000,*/
            updateArgs: [true, true, { duration: 1000 }],
            advancedTrendChartOptions: {
                chart: {
                    type: 'spline',
                    // marginRight: 80, // like left
                    height: '45%',
                    // width: '80%',
                    zoomType: 'x',
                    resetZoomButton: {
                        position: {
                            // align: 'right', // by default
                            // verticalAlign: 'top', // by default
                            x: 0,
                            y: -30,
                        },
                    },
                },
                time: { useUTC: false, timezone: 'Australia/Melbourne', },
                title: {
                    text: 'Device Trends'
                },
                series: this.advancedTrendSeries,
                legend: { enabled: true, },
                rangeSelector: {
                    enabled: false,
                    // selected: 5
                },
                exporting: { enabled: true, showTable: false, filename: 'DeviceTrends_' + this.item.id },
                xAxis: [{ type: 'datetime', title: { text: 'Time' }, }],
                yAxis: [{ opposite: false, title: { text: 'Trends' } }, { opposite: true, title: { text: 'LT Supply Pressure' } }],
            }
        }
    },

    props: ['item'],
    async mounted() {

        this.refreshAdvancedTrendsData();

        this.refreshAdvancedTrendsDataIntervalID = setInterval(() => {
            if (this.refreshAdvancedTrendsDataActive) {
                this.refreshAdvancedTrendsData()
            }
        }, 60000) // 1 min    
    },
    methods: {
        beforeDestroy() {
            this.trendsData = [];
            clearInterval(this.refreshAdvancedTrendsDataIntervalID);
        },
        async refreshAdvancedTrendsData() {
            this.advancedTrendsLoaded = false;
            this.advancedTrendChartOptions.series = null;
            this.advancedTrendSeries = null;
            this.advancedTrendsFound = false;

            console.log("Loading fresh Trend data for Start: " + this.trendStartStamp + " and End: " + this.trendEndStamp);

            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices/" + this.item.id + "/data?mode=trend&startDate=" + this.trendStartStamp + "&endDate=" + this.trendEndStamp
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                var pids_lc_flow_pid_pv = []
                var analogs_ht_sct_scaled = []
                var analogs_lc_lrt_scaled = []
                var analogs_lt_dst_scaled = []
                var analogs_lt_scp_scaled = []
                var analogs_lt_sct_scaled = []
                var pids_lc_flow_pid_out = []

                this.advancedTrends = response.data;

                for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i]

                    // var curTrend = [new Date(element.t_stamp).toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }), element.TagValue.toFixed(1)];
                    var curTrend = [element.t_stamp, element.TagValue.toFixed(1)].map(Number);
                    //curTrend = curTrend.map(Number);

                    if (element.Tag == 'pids_lc_flow_pid_pv') { this.advancedTrendsFound = true; pids_lc_flow_pid_pv.push(curTrend);}
                    if (element.Tag == 'analogs_ht_sct_scaled') { this.advancedTrendsFound = true; analogs_ht_sct_scaled.push(curTrend);}
                    if (element.Tag == 'analogs_lc_lrt_scaled') { this.advancedTrendsFound = true; analogs_lc_lrt_scaled.push(curTrend);}
                    if (element.Tag == 'analogs_lt_dst_scaled') { this.advancedTrendsFound = true; analogs_lt_dst_scaled.push(curTrend);}
                    if (element.Tag == 'analogs_lt_scp_scaled') { this.advancedTrendsFound = true; analogs_lt_scp_scaled.push(curTrend);}
                    if (element.Tag == 'analogs_lt_sct_scaled') { this.advancedTrendsFound = true; analogs_lt_sct_scaled.push(curTrend);}
                    if (element.Tag == 'pids_lc_flow_pid_out') { this.advancedTrendsFound = true; pids_lc_flow_pid_out.push(curTrend);}
                }

                this.advancedTrendSeries =
                    [
                        {
                            name: 'Flow Actual',
                            data: (pids_lc_flow_pid_pv.length == 0 ? [] : pids_lc_flow_pid_pv),
                            yAxis: 1,
                            // type: 'line'
                        },
                        {
                            name: 'HT Supply Temp',
                            data: (analogs_ht_sct_scaled.length == 0 ? [] : analogs_ht_sct_scaled),
                            yAxis: 0,
                            // type: 'line'
                        },
                        {
                            name: 'Liquid Temp',
                            data: (analogs_lc_lrt_scaled == 0 ? [] : analogs_lc_lrt_scaled),
                            yAxis: 0,
                            // type: 'line'
                        },
                        {
                            name: 'LT Discharge Temp',
                            data: (analogs_lt_dst_scaled == 0 ? [] : analogs_lt_dst_scaled),
                            yAxis: 1,
                            // type: 'line'
                        },
                        {
                            name: 'LT Supply Pressure',
                            data: (analogs_lt_scp_scaled == 0 ? [] : analogs_lt_scp_scaled),
                            yAxis: 1,
                            // type: 'column',
                        },
                        {
                            name: 'LT Supply Temp',
                            data: (analogs_lt_sct_scaled == 0 ? [] : analogs_lt_sct_scaled),
                            yAxis: 0,
                            // type: 'line'
                        },
                        {
                            name: 'Pump Output',
                            data: (pids_lc_flow_pid_out == 0 ? [] : pids_lc_flow_pid_out),
                            yAxis: 1,
                            // type: 'spline',

                        }
                    ];

                this.advancedTrendChartOptions.series = this.advancedTrendSeries;
                this.advancedTrendsLoaded = true;
                    console.log("Trends loaded...")
                    console.log(this.advancedTrendChartOptions.series)
            } catch (error) {
                console.log(error);
            }
        },
        loadTrends(){
            this.refreshAdvancedTrendsActive = false;
            
            this.trendStartStamp = this.time3[0];
            this.trendEndStamp = this.time3[1];
            clearInterval(this.refreshAdvancedTrendsDataIntervalID);
            this.refreshAdvancedTrendsData();
        },

    },
};
</script>

<style>

button#btnLoadTrends {
    margin-left: 10px;
}

</style>